import { useQuery } from '@tanstack/react-query';
export function useCreateCollection(collectionName, contentIds) {
    const body = JSON.stringify({ name: collectionName, contentIds: contentIds ? contentIds : [] });
    const fetcher = async () => await fetch(`/API/collections`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body,
    }).then((res) => res.json());
    const { refetch, isFetching, isError } = useQuery({
        queryKey: ['allCollections', collectionName],
        queryFn: fetcher,
        enabled: false,
    });
    return { refetch, isFetching, isError };
}
